<ntv-modal
    size="xlarge"
    [isVisible]="showAddContentModal()"
    [showHeader]="true"
    [showFooter]="true"
    (modalClose)="onClose()">
    <div modal-header class="modal__header" title="Close add content modal">
        <h3 class="modal__header--title">
            Add content - {{ selectedContentType() === 'single' ? 'Single' : 'Block' }}
        </h3>
        <button class="modal__header--close" (click)="onClose()">
            <svg width="20" height="20">
                <use [attr.xlink:href]="'assets/icons/icons-sprite.svg#close'"></use>
            </svg>
        </button>
    </div>

    <div class="modal__body">
        <ntv-stepper
            [steps]="addContentSteps"
            [config]="stepperConfig()"
            [currentStep]="currentStepIndex()" />

        <div class="modal__steps">
            @switch (currentStepIndex()) {
                @case (0) {
                    <app-select-assets-modal
                        [showTabs]="false"
                        [selectedContentType]="selectedContentType()"
                        [dealerId]="dealerId()" />
                }
                @case (1) {
                    <app-preview />
                }
                @case (2) {
                    <app-settings />
                }
                @default {
                    <div class="flex items-center justify-center h-full text-gray-400 italic">
                        Step component not implemented yet
                    </div>
                }
            }
        </div>
    </div>

    <div modal-footer class="modal__footer">
        <div class="modal__footer--controls">
            @if (currentStepIndex() > 0) {
                <ntv-button size="xl" (buttonClick)="onPreviousStep()">
                    <span class="btn-span--md">Previous</span>
                </ntv-button>
            }
            <ntv-button
                size="xl"
                variant="accent"
                [disabled]="!isCurrentStepValid() || isSaving()"
                [loading]="isSaving()"
                (buttonClick)="onNextStep()">
                <span class="btn-span--md">
                    {{
                        currentStepIndex() === addContentSteps.length - 1
                            ? 'Add to Playlist'
                            : 'Next'
                    }}
                </span>
            </ntv-button>
        </div>
    </div>
</ntv-modal>

<!-- Success/Error Result Modal -->
@if (showResultModal()) {
    <app-confirmation-modal
        [type]="resultModalConfig().type"
        [isVisible]="showResultModal()"
        [loopAnimation]="false"
        [title]="resultModalConfig().title"
        [message]="resultModalConfig().message"
        confirmText="Close"
        (confirm)="onResultModalClose()"
        (modalClose)="onResultModalClose()" />
}
